import { RadioButton } from "@habitech/selectors"
import {
    ContainerSwitch,
    FormGroup,
    Grid,
    Label,
    RadioLabel,
    RangeContainer,
    Section,
    SQLTextArea
} from "../FormElement/styles"
import { Calendar as CalendarComponent } from '../calendar/calendar';
import { ButtonGroup } from "../../styles"
import { TextField } from "@habitech/keychain-atoms-inputs"
import { NotificationsContext } from "../../context/NotificationContext"
import { Button as ButtonKeychain } from "@habitech/call-to-action"
import { useContext } from "react"
import { GridContainer, GridItem } from "src/components/common/grids";
import { MaterialSwitch } from "../FormElement/FormElements";
import { TabBarContext } from "src/components/common/TabSwich";
import { PreViewComponent } from "../preView/preViewComponent";

interface UserType {
    id: string;
    name: string;
    value: string;
}


const userTypes: UserType[] = [
    { id: 'owner', name: 'Propietario', value: 'Owner' },
    { id: 'independent', name: 'Agente Independiente', value: 'Independent agent' },
    { id: 'medium_broker', name: 'Medium Broker', value: 'Medium broker' },
    { id: 'big_broker', name: 'Big Broker', value: 'Big broker' }
];


export const AudienceComponent = () => {
    const {
        dataFilters,
        errors,
        isValid,
        selectedUserTypes,
        hasFeatured,
        customQuery,
        setCustomQuery,
        handleSetDataFilters,
        handleUserTypeToggle,
        handleSetHasFeatured,
        handleOpenModal,
        handleResetForm,
        handleSetLeadsDate
    } = useContext(NotificationsContext)

    const { setTab } = useContext(TabBarContext);

    const handleCancel = () => {
        handleResetForm()
        setTab('tab-1')
    }

    return <Section>
        <GridContainer>
            <GridItem lg={6}>

                <FormGroup>
                    <Label htmlFor="user_source">Fuente de usuarios</Label>
                    <div>
                        <RadioLabel>
                            <RadioButton
                                key={"userSouce_feed"}
                                originType="pcom"
                                dataId={"userSouce_feed"}
                                id={"userSouce_feed"}
                                name="user_source"
                                value="feed"
                                selected={dataFilters.user_source}
                                onChange={handleSetDataFilters.bind(null, 'user_source')}
                            />
                            Feed
                        </RadioLabel>
                        <RadioLabel>
                            <RadioButton
                                key={"userSouce_manual"}
                                originType="pcom"
                                dataId={"userSouce_manual"}
                                id={"userSouce_manual"}
                                name="user_source"
                                value="manual"
                                selected={dataFilters.user_source}
                                onChange={handleSetDataFilters.bind(null, 'user_source')}
                            />
                            Manual
                        </RadioLabel>
                        <RadioLabel>
                            <RadioButton
                                key={"userSouce_custom"}
                                originType="pcom"
                                dataId={"userSouce_custom"}
                                id={"userSouce_custom"}
                                name="user_source"
                                value="custom-query"
                                selected={dataFilters.user_source}
                                onChange={handleSetDataFilters.bind(null, 'user_source')}
                            />
                            Custom Query
                        </RadioLabel>
                    </div>
                </FormGroup>
                {dataFilters.user_source === 'custom-query' && (
                    <FormGroup>
                        <Label htmlFor="custom-query">
                            SQL Query Personalizado
                        </Label>
                        <div className="flex gap-2">
                            <SQLTextArea
                                id="custom-query"
                                name="custom-query"
                                value={customQuery}
                                onChange={(e) => setCustomQuery(e.target.value)}
                                placeholder="SELECT * FROM users WHERE..."
                            />
                        </div>
                    </FormGroup>
                )}
                {dataFilters.user_source !== 'custom-query' && <>
                    <FormGroup>
                        <Label>Tipo de usuario</Label>
                        <ContainerSwitch>
                            {userTypes.map((type) => (
                                <MaterialSwitch
                                    key={type.id}
                                    checked={selectedUserTypes.includes(type.value)}
                                    onChange={handleUserTypeToggle.bind(null, type.value)}
                                >
                                    {type.name}
                                </MaterialSwitch>
                            ))}
                        </ContainerSwitch>
                    </FormGroup>

                    <FormGroup>
                        <Label>Número de propiedades destacadas</Label>
                        <MaterialSwitch
                            checked={hasFeatured}
                            onChange={handleSetHasFeatured.bind(null)}
                        >
                            Tiene propiedades destacadas
                        </MaterialSwitch>

                        {hasFeatured && (
                            <RangeContainer>
                                <Label>Entre</Label>
                                <TextField
                                    dataId='featuredMin'
                                    name='featuredMin'
                                    type="number"
                                    value={dataFilters.featuredMin}
                                    onChange={handleSetDataFilters.bind(null)}
                                    error={!!errors['featuredMin']}
                                    errorMessage={errors['featuredMin']}
                                />
                                <Label>y</Label>
                                <TextField
                                    dataId='featuredMax'
                                    name='featuredMax'
                                    type="number"
                                    value={dataFilters.featuredMax}
                                    onChange={handleSetDataFilters.bind(null)}
                                    error={!!errors['featuredMax']}
                                    errorMessage={errors['featuredMax']}
                                />
                                <Label>propiedades</Label>
                            </RangeContainer>
                        )}
                    </FormGroup>
                </>}
            </GridItem>
            <GridItem lg={6}>
                {dataFilters.user_source !== 'custom-query' && <>
                    <FormGroup>
                        <Label>
                            Cantidad de inventario activo
                        </Label>

                        {(
                            <RangeContainer>
                                <Label>Entre</Label>
                                <TextField
                                    name='propertiesActiveMin'
                                    dataId='propertiesActiveMin'
                                    type="number"
                                    value={dataFilters.propertiesActiveMin}
                                    onChange={handleSetDataFilters.bind(null)}
                                    error={!!errors['propertiesActiveMin']}
                                    errorMessage={errors['propertiesActiveMin']}
                                />
                                <Label>y</Label>
                                <TextField
                                    name='propertiesActiveMax'
                                    dataId='propertiesActiveMax'
                                    type="number"
                                    value={dataFilters.propertiesActiveMax}
                                    onChange={handleSetDataFilters.bind(null)}
                                    error={!!errors['propertiesActiveMax']}
                                    errorMessage={errors['propertiesActiveMax']}
                                />
                                <Label>propiedades</Label>
                            </RangeContainer>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label>
                            Leads recibidos
                        </Label>

                        {(
                            <>
                                <RangeContainer>
                                    <Label>Entre</Label>
                                    <TextField
                                        name='leadsMin'
                                        dataId='leadsMin'
                                        type="number"
                                        value={dataFilters.leadsMin}
                                        onChange={handleSetDataFilters.bind(null)}
                                        error={!!errors['leadsMin']}
                                        errorMessage={errors['leadsMin']}
                                    />
                                    <Label>y</Label>
                                    <TextField
                                        name='leadsMax'
                                        dataId='leadsMax'
                                        type="number"
                                        value={dataFilters.leadsMax}
                                        onChange={handleSetDataFilters.bind(null)}
                                        error={!!errors['leadsMax']}
                                        errorMessage={errors['leadsMax']}
                                    />
                                    <Label>leads</Label>
                                </RangeContainer>

                                <div style={{ marginTop: '0.5rem' }}>
                                    <Label className='dates'>Intervalo de fechas de creación de leads</Label>
                                    <RangeContainer>
                                        <Grid className='calendar'>
                                            <div>
                                                <Label htmlFor="leadsDateMin">Fecha de inicio</Label>
                                                <CalendarComponent id='leadsDateMin' name='leadsDateMin' value={dataFilters.leadsDateMin} handleChange={handleSetLeadsDate.bind(null)} />
                                            </div>

                                            <div>
                                                <Label htmlFor="leadsDateMax">Fecha de fin</Label>
                                                <CalendarComponent id='leadsDateMax' name='leadsDateMax' value={dataFilters.leadsDateMax} handleChange={handleSetLeadsDate.bind(null)} />
                                            </div>
                                        </Grid>

                                    </RangeContainer>
                                </div>
                            </>
                        )}
                    </FormGroup></>}
            </GridItem>
        </GridContainer>
        <ButtonGroup>
            <ButtonKeychain dataId='cancel' variant='stroke' onClick={handleCancel} originType='pcom'>Cancelar</ButtonKeychain>
            <ButtonKeychain dataId='send' originType='pcom' onClick={handleOpenModal} disabled={!isValid}>Ver alcance</ButtonKeychain>
        </ButtonGroup>
        <PreViewComponent />
    </Section>

}